// extracted by mini-css-extract-plugin
export var root = "pUwU";
export var rootHeading = "k3iw";
export var rootItemImage = "qLL8";
export var rootItemPicture = "_6OnZ";
export var rootItems = "zL2O";
export var rootSocial = "AdaN";
export var rootSocialIcon = "lIuD";
export var rootSocials = "c6Lz";
export var rootWave = "EThe";
export var rootWhite = "_0UW2";